import { useAdminRequestScope } from "./useAdminRequestScope";
import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import type { Notify, AuditRow } from "./admin-types";

export function useAdminAuditWorkspace({notify}: {notify: Notify}) {
  const scope = useAdminRequestScope(notify);
  const [rows, setRows] = useState<AuditRow[]>([]);
  const load = useCallback(() => {
    if (!scope.isMounted()) return;
    const request = scope.beginRead();
    void apiRequest<AuditRow[]>("/api/admin/audit").then(value => {
      if (scope.isCurrentRead(request)) setRows(value);
    }).catch((error: unknown) => {
      if (scope.isCurrentRead(request)) scope.notify(error instanceof Error ? error.message : "Güvenlik kayıtları alınamadı.");
    });
  }, [scope]);
  useEffect(load, [load]);
  return { rows };
}
